var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { c } from '@/shared/utils/c';
export var TaskBoardKPIFilterButton = function (_a) {
    var label = _a.label, amount = _a.amount, isActive = _a.isActive, color = _a.color, onClick = _a.onClick;
    return (_jsxs("div", __assign({ className: "".concat(isActive ? 'selected' : '', " kpi-block flex-child-block"), onClick: onClick }, { children: [_jsx("h2", __assign({ className: "kpi-title" }, { children: label })), _jsx("h1", __assign({ className: c('bold', color && amount > 0 && color) }, { children: amount }))] })));
};
